import { render, staticRenderFns } from "./lkuCustomerGroup.vue?vue&type=template&id=37348e56"
import script from "./lkuCustomerGroup.vue?vue&type=script&lang=js"
export * from "./lkuCustomerGroup.vue?vue&type=script&lang=js"
import style0 from "./lkuCustomerGroup.vue?vue&type=style&index=0&id=37348e56&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports